import { window } from "global";
import { useEffect } from "react";
import { MediaQuery } from "@outplayed/responsive";
import { TierListHeader } from "../../TierListHeader";
import { TierListPageNav } from "../../TierListPageNav";
import { TierListFilterManager } from "../../TierListFilterManager";
import { ArenaDuoTierListTable } from "./ArenaDuoTierListTable";
import { TierListTablePlaceholder } from "../../common/TierListTablePlaceholder";
import { TierListTableError } from "../../common/TierListTableError";
import { useArenaDuoTierList } from "@ugg/shared/api/requests/tier-lists/arena-duo-tier-list";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { SPECIAL_TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getArenaModeType } from "@ugg/shared/utils/queue-type-helpers";

type BannerProp = {
  bannerSlot?: JSX.Element | null;
  patchNotesCTA?: React.ReactNode;
};

export const ArenaDuoTierListContainer = ({ bannerSlot, patchNotesCTA }: BannerProp) => {
  const params = useQueryString();
  const { data: duoData, loading, error } = useArenaDuoTierList({ params, ssr: true });
  const { data, lastUpdated, totalMatches } = duoData || {};

  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(SPECIAL_TIER_LIST_PAGES.ARENA_DUO_TIER_LIST, params, true);
  const arenaModeType = getArenaModeType(validatedQueryParams.patch);

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  let table = null;
  if (!window) {
    table = null;
  } else if (loading) {
    table = <TierListTablePlaceholder />;
  } else if (error) {
    table = <TierListTableError />;
  } else {
    table = <ArenaDuoTierListTable data={data["none_none"] || []} arenaModeType={arenaModeType} />;
  }

  return (
    <div>
      <TierListHeader
        className="mb-[24px]"
        totalMatches={totalMatches}
        lastUpdated={lastUpdated}
        loading={loading}
        includeMeta
        patchNotesCTA={patchNotesCTA}
      />
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div>
          <TierListPageNav />
        </div>
      </MediaQuery>
      {bannerSlot ?? null}
      <TierListFilterManager className="my-[24px]" />
      {table}
    </div>
  );
};
